var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-bg px-2",class:_vm.orderStatus},[_vm._v(" "+_vm._s(_vm._f("textFormat")(_vm.$t(_vm.orderStatus)))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }